import { createModal } from 'react-modal-promise'
import Modal from '../components/Modal.tsx'

// @ts-ignore TODO: types
export const fireModal = createModal(Modal)
